import { PUT_OUR_WORK_ERROR, PUT_OUR_WORK_START, PUT_OUR_WORK_SUCCESS } from '../../types';

export default function put_our_work(state, action) {
  switch (action.type) {
    case PUT_OUR_WORK_START:
      return { ...state };
    case PUT_OUR_WORK_SUCCESS:
      return {
        ...state,
        data: action.results,
        error: null,
      };
    case PUT_OUR_WORK_ERROR:
      return {
        ...state,
        data: null,
        error: action.error
      };
    default:
      return { ...state };
  }
}